<template lang="html">
  <div class="w-auto flex flex-row flex-wrap sm:flex-no-wrap" :style="getStyle">
    <a v-for="link in links" :href="link.path" class="mr-0 sm:mr-4 font-light fs-link top-nav group" :id="`${link.id}_button`">
      <!-- <inline-svg width="25" height="25" :src="link.image_path" class="top-nav-svg" :class="Window.location.pathname == link.path ? 'active' : ''"></inline-svg> -->
      <div class="py-2 xs:py-3 px-3 xs:px-4 md:px-6 cursor-pointer flex items-center m-1" :class="getClass(link)">
        <div v-if="link.selected_image_path || link.image_path">
          <inline-svg v-if="isActiveLink(link)"  width="20" height="20" :src="link.selected_image_path" class="active h-4 xs:h-5 md:h-6"></inline-svg>
          <div v-else>
            <svg v-if="link.path == '/feed'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 180" fill="currentColor" class="h-4 xs:h-5 md:h-6">
              <path d="m119.63,74.03c-13.92,3.46-22.95,10.7-27.08,21.7.06.18.09.34.09.46v52.24c0,1.1-.4,2.04-1.18,2.83-.67.73-1.55,1.09-2.65,1.09-1.15,0-2.1-.36-2.82-1.09-.73-.79-1.1-1.73-1.1-2.83v-51.87c0-1.58.03-3.1.09-4.56-2.55-46.38,26.47-62.45,87.07-48.23-12.82,57.56-37.9,77.77-75.22,60.63,1.7-12.34,9.45-22.49,23.25-30.45-.06,0-.21.03-.46.09Zm-53.97,27.9c-4.86-7.05-12.25-12.09-22.15-15.13,10.82,7.66,17.14,15.92,18.96,24.8-25.59,9.24-43.76-6.08-54.52-45.95,43.34-8.33,65.19,3.22,65.55,34.65.06.12.09.3.09.54v.46c0,.43-.03.91-.09,1.46v45.67c0,1.1-.4,2.04-1.18,2.83-.73.73-1.64,1.09-2.74,1.09s-2.04-.36-2.83-1.09c-.73-.79-1.09-1.73-1.09-2.83v-45.86c0-.25,0-.46,0-.64Z"/>
            </svg>
            <svg v-if="link.path == '/highlights'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 180" fill="currentColor" class="h-4 xs:h-5 md:h-6">
              <path fill-rule="evenodd" d="m75.65,51.9c-3.33-1.87-6.41-4.14-9.17-6.75-5.57-5.29-10.01-12.05-13.18-20.1l-4.61-11.72-4.61,11.72c-3.17,8.05-7.6,14.81-13.17,20.1-2.77,2.63-5.86,4.9-9.17,6.76l-7.71,4.32,7.71,4.32c3.31,1.86,6.4,4.13,9.17,6.76,5.57,5.28,10.01,12.04,13.18,20.09l4.61,11.72,4.61-11.72c3.17-8.05,7.6-14.81,13.18-20.1,2.77-2.63,5.86-4.9,9.18-6.76l7.71-4.32-7.71-4.32Z" clip-rule="evenodd" />
              <path fill-rule="evenodd" d="m156.64,103.22c-3.38-1.9-6.52-4.21-9.32-6.86-5.72-5.42-10.29-12.41-13.57-20.75l-9.23-23.44-9.23,23.44c-3.28,8.34-7.85,15.32-13.57,20.75-2.81,2.67-5.95,4.98-9.31,6.87l-15.41,8.65,15.41,8.65c3.36,1.89,6.5,4.2,9.31,6.87,5.72,5.43,10.29,12.41,13.57,20.75l9.23,23.44,9.23-23.44c3.28-8.34,7.85-15.32,13.57-20.75,2.82-2.67,5.95-4.98,9.32-6.87l15.42-8.65-15.42-8.65Z" clip-rule="evenodd" />
              <path fill-rule="evenodd" d="m76.67,136.86c-1.47-.82-2.83-1.83-4.05-2.98-2.48-2.35-4.47-5.38-5.89-9l-4.01-10.18-4,10.18c-1.42,3.62-3.41,6.65-5.89,9-1.22,1.16-2.58,2.16-4.04,2.98l-6.69,3.75,6.69,3.75c1.46.82,2.82,1.82,4.04,2.98,2.48,2.36,4.47,5.38,5.89,9l4,10.18,4.01-10.18c1.42-3.62,3.41-6.65,5.89-9,1.22-1.16,2.58-2.16,4.04-2.98l6.69-3.75-6.69-3.75Z" clip-rule="evenodd" />
            </svg>
            <svg v-if="link.path == '/bookmarks'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 180" fill="currentColor" class="h-4 xs:h-5 md:h-6">
              <path d="m31.01,16.2c-2.95,0-5.36,2.41-5.36,5.36h0v139.43c0,2.95,2.41,5.36,5.36,5.36,1.07,0,2.41-.27,3.22-1.07h0l55.77-40.49,55.77,40.49c.8.54,1.88,1.07,3.22,1.07,2.95,0,5.36-2.41,5.36-5.36V21.56c0-2.95-2.41-5.36-5.36-5.36H31.01Z"/>
            </svg>
            <svg v-if="link.path.includes('my_wellness_journey')" xmlns="http://www.w3.org/2000/svg" class="h-4 xs:h-5 md:h-6 " fill="currentColor" viewBox="0 0 180 180"><path d="m30.61 79.64 18.44 7.74c-2.08 5.32-3.74 10.79-4.96 16.37l-.7 3.22 26.43 26.79 3.18-.69a106.06 106.06 0 0 0 16.16-5.02l7.64 18.68a1.192 1.192 0 0 0 1.96.39l11.55-11.71c3.81-3.86 5.83-9.18 5.56-14.64l-.41-7.52c21.39-16 43.04-44.07 48.93-93.05.6-4.4-2.44-8.47-6.79-9.08-.71-.1-1.42-.1-2.13 0-48.33 6.02-76.05 27.97-91.84 49.57l-7.41-.39c-5.37-.3-10.62 1.72-14.45 5.55L30.22 77.56c-.5.43-.56 1.19-.14 1.7.14.16.32.29.52.36Zm74.13-28.53c5.6-5.65 14.65-5.63 20.23.04s5.56 14.84-.04 20.49a14.161 14.161 0 0 1-20.19 0c-5.6-5.65-5.61-14.82-.04-20.49l.04-.04Zm-77.58 84.81a18.535 18.535 0 0 0-9.54-.77c-.58.13-1.18-.06-1.59-.48-.52-.52-.66-1.31-.35-1.98 3.39-7.37 12.36-22.2 28.62-10.22.33.3.36.82.06 1.16l-.06.06c-4.41 3.52-6.91 8.96-6.72 14.65.02.68.57 1.23 1.24 1.26 5.59.23 10.96-2.25 14.46-6.67a.81.81 0 0 1 1.26 0c2.26 2.72 8.47 11.61 1.59 20.19-3 3.66-7.31 5.97-11.98 6.44-6.67.72-19.01 2.93-24.05 8.76-.62.74-1.71.83-2.44.21-.26-.22-.45-.52-.55-.85-1.78-6.15-4.55-19.9 10.04-31.75Z"/></svg>
          </div>
        </div>
        <span class="text-xs xs:text-sm md:text-base ml-1 xs:ml-2" :class="getTextClass(link)">{{ link.text }}</span>
      </div>
    </a>
  </div>
</template>

<script>
  import InlineSvg from 'vue-inline-svg';

  export default {
    components: {
      InlineSvg
    },
    props: {
      link_data: {
        type: String,
        required: true
      },
      organization_id: String,
      role: String,
      tour: String
    },
    data: function() {
      return {
        links: JSON.parse(this.link_data).data.attributes.links,
        isiPad: false,
      }
    },
    mounted: function() {
      // if (this.organization_id !== ''){
      //   this.selectDefaultTab()
      // }
    },
    created() {
      this.checkIfiPad();
    },
    computed : {
      getStyle() {
        if (window.innerWidth < 480) {
          const width = window.innerWidth;
          if (this.links.length > 3) {
            const zoom = width / 425 * 100;
            return `zoom: ${zoom}%;`;
          } else {
            const zoom = width / 415 * 100;
            return `zoom: ${zoom}%;`;
          }
        } else {
          const width = window.innerWidth;
          if (window.innerWidth > 1199) {
            return `zoom: 99%;`;
          } else if (window.innerWidth > 991) {
            const zoom = width / 1710 * 100;
            return `zoom: ${zoom}%;`;
          } else if (window.innerWidth > 767) {
            const zoom = width / 1536 * 100;
            return `zoom: ${zoom}%;`;
          } else {
            return `zoom: 100%;`;
          }
        }
      },
    },
    methods: {
      // selectDefaultTab(){
      //   window.location = "/feed"
      // }

      getClass(link){
        if (window.location.pathname == link.path && this.tour === "false"){
          return 'rs-filter-btn text-white'
        }else if(window.location.pathname != link.path && this.tour === "false"){
          return 'text-slategrey rs-filter-btn-hover hs-outline-btn'
        }else{
          return 'text-slategrey hs-outline-btn'
        }
      },

      getTextClass(link){
        if (window.location.pathname == link.path && this.tour === "false"){
          if (this.isiPad) {
            return 'text-white SofiaPro-Light';
          } else {
            return 'text-white';
          }
        } else if(window.location.pathname != link.path && this.tour === "false") {
          if (this.isiPad) {
            return 'rs-text-grey SofiaPro-Light';
          } else {
            return 'rs-text-grey';
          }
        } else{
          if (this.isiPad) {
            return 'rs-text-grey SofiaPro-Light';
          } else {
            return 'rs-text-grey';
          }
        }
      },
      isActiveLink(link) {
        return window.location.pathname == link.path;
      },
      checkIfiPad() {
        const userAgent = navigator.userAgent;
        this.isiPad = /iPad/.test(userAgent);
      },
    }
  }
</script>

<style lang="scss">
.rs-text-grey {
  color: #708090;
}

.abc>svg>path {
    fill: red;
}

path:hover {
    fill: red;
}



  .top-nav-svg-1 {
      width: 50px;
      height: 50px;
      margin: auto;
      .circle-outline {
          fill: red;
      }
      .icon {
          fill: green;
      }
      &:hover {
          background: red;
          border-radius: 100%;
          .icon {
              fill: blue;
          }
      }

      path {
        fill: red !important;
      }
  }

  .top-nav-title {
      // margin-top: 4px;

      font-family: Poppins;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;

      &:hover,
      &.active {
          @apply text-filterblue;
      }
  }
  @responsive {
    .f-14 {
      font-size: 14px;
    }
    .f-12 {
      font-size: 12px;
    }
  }

  .rs-filter-btn-hover {
    background-color: red;
    &:hover {
      background-color: green;
    }
  }
</style>

<style lang="scss" scoped>
  .text-color {
    color: #10083c;
  }
</style>
